import { Location } from "history";
import { matchPath } from "react-router-dom";

import { PartialLocation } from "common/types/routing";

import {
  SESSION_TYPES,
  SessionType
} from "seneca-common/features/session/models/SessionType";

import linkToQuitSessionWithDestination from "features/classroom/pages/classroom/components/QuitSessionModal/utils/linkToQuitSessionWithDestination";
import { linkToQuitSectionSessionWithDestination } from "features/classroom/routes/links";
import { ROUTES } from "routing/routes";

export function linkThroughQuitSessionModal({
  courseId,
  link,
  sessionType,
  warnBeforeNavigation,
  activeSectionId,
  currentLocation
}: {
  warnBeforeNavigation: boolean;
  courseId: string;
  activeSectionId?: string;
  sessionType: SessionType;
  link: string | PartialLocation;
  currentLocation: Location<any>;
}) {
  if (!warnBeforeNavigation) {
    return link;
  }

  const isLinkToSection = matchPath(link.toString(), {
    path: ROUTES.CLASSROOM.COURSE.SECTION.path
  }) as any;

  if (
    sessionType === SESSION_TYPES.multiSection ||
    sessionType === SESSION_TYPES.vocabulary ||
    !isLinkToSection
  ) {
    return linkToQuitSessionWithDestination({
      link,
      currentLocation
    });
  }

  return linkToQuitSectionSessionWithDestination(
    courseId,
    activeSectionId,
    link
  );
}
